import { v4 as uuidv4 } from 'uuid';

/**
 * Function for generating an array of UUID's - useful for record identification.
 * @param num
 */
const generateUids = (num: number): Array<string> => Array.from(Array(num).keys()).map(() => uuidv4());
export default generateUids;
